/**
 * Cart Drawer Discount Code Input
 * Apply promo codes via /discount/CODE endpoint, re-render cart sections.
 *
 * ARCHITECTURE: Uses event delegation on document level so listeners
 * survive innerHTML replacements from Dawn's renderContents().
 */
(function () {
  // Event delegation — survives innerHTML replacements
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.id || form.id !== 'CartDrawer-DiscountForm') return;

    event.preventDefault();
    event.stopPropagation();

    var input = document.getElementById('CartDrawer-DiscountInput');
    var errorEl = document.getElementById('CartDrawer-DiscountError');
    var applyBtn = document.getElementById('CartDrawer-DiscountApply');
    var code = input ? input.value.trim() : '';

    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }

    if (!code) {
      if (errorEl) {
        errorEl.textContent = 'Please enter a discount code.';
        errorEl.style.display = 'block';
      }
      return;
    }

    if (applyBtn) {
      applyBtn.disabled = true;
      applyBtn.textContent = 'Applying...';
    }

    // Apply discount via /discount/CODE — sets the discount server-side
    fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      redirect: 'follow'
    })
      .then(function () {
        // Re-fetch cart drawer section to see updated discounts
        return fetch('/?sections=cart-drawer,cart-icon-bubble');
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        if (window._updateCartDrawerSections) {
          window._updateCartDrawerSections(sections);
        }
        // Reset input
        var newInput = document.getElementById('CartDrawer-DiscountInput');
        if (newInput) newInput.value = '';
        var newBtn = document.getElementById('CartDrawer-DiscountApply');
        if (newBtn) {
          newBtn.disabled = false;
          newBtn.textContent = 'Apply';
        }
      })
      .catch(function () {
        // Fallback: full page reload to apply discount
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      });
  });
})();
